import React from 'react'
import Service from '../components/Services/Service'
import SecondBanner from '../components/Banner/SecondBanner'
import ProductDetails from '../components/Services/ProductDetails'

const service = () => {
  return (
    <>
    <SecondBanner title="Products" breadcrumbText="Products"/>
    <ProductDetails/>
    </>
  )
}
export default service